import { render, staticRenderFns } from "./HeaderControls.vue?vue&type=template&id=53dd5e19&scoped=true&"
import script from "./HeaderControls.vue?vue&type=script&lang=js&"
export * from "./HeaderControls.vue?vue&type=script&lang=js&"
import style0 from "./HeaderControls.vue?vue&type=style&index=0&id=53dd5e19&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53dd5e19",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/workflow.dashtogo.com/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53dd5e19')) {
      api.createRecord('53dd5e19', component.options)
    } else {
      api.reload('53dd5e19', component.options)
    }
    module.hot.accept("./HeaderControls.vue?vue&type=template&id=53dd5e19&scoped=true&", function () {
      api.rerender('53dd5e19', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/common/HeaderControls.vue"
export default component.exports